module.exports = __webpack_public_path__ + "static/icon-marry.0e6c2db0.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-marry.png
// module id = 290
// module chunks = 2